import { render, staticRenderFns } from "./DetailsClient.vue?vue&type=template&id=83e457cc&"
import script from "./DetailsClient.vue?vue&type=script&lang=js&"
export * from "./DetailsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports